interface DettagliEventoSectionProps {
  onCtaClick: () => void;
}

export default function DettagliEventoSection({ onCtaClick }: DettagliEventoSectionProps) {
  return (
    <section className="py-28 bg-black relative overflow-hidden" id="evento">
      {/* Background decoration */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, #D4AF37 0%, transparent 50%), radial-gradient(circle at 80% 50%, #D4AF37 0%, transparent 50%)',
        }}
      />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <span
            className="inline-block bg-yellow-600 text-black text-xs tracking-widest uppercase px-5 py-2 rounded-full mb-6 mx-auto md:mx-0 font-bold"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Evento Esclusivo
          </span>
          <h2
            className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
          >
            Casting Open Day
          </h2>
          <p
            className="text-white/70 text-lg"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Il tuo primo passo verso il successo nel mondo dello spettacolo
          </p>
        </div>

        {/* Main Card */}
        <div
          className="rounded-2xl border-2 overflow-hidden mx-auto"
          style={{
            maxWidth: '1000px',
            borderColor: '#D4AF37',
            background: 'linear-gradient(135deg, #141414 0%, #0a0a0a 100%)',
            boxShadow: '0 20px 60px rgba(212, 175, 55, 0.2)',
          }}
        >
          {/* Top golden bar */}
          <div
            className="h-1 w-full"
            style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}
          />

          <div className="p-6 md:p-10 lg:p-14">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 items-start">
              {/* Data e ora */}
              <div className="text-center md:text-left">
                <div className="w-14 h-14 flex items-center justify-center rounded-full border border-yellow-600/50 bg-yellow-600/10 mb-6 mx-auto md:mx-0">
                  <i className="ri-calendar-event-line text-2xl" style={{ color: '#D4AF37' }} />
                </div>
                <div
                  className="text-xs tracking-widest uppercase text-gray-500 mb-3"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Data &amp; Ora
                </div>
                <div
                  className="text-2xl font-bold text-white mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Lunedì 30 Marzo
                </div>
                <div
                  className="text-xl font-semibold"
                  style={{ fontFamily: "'Playfair Display', serif", color: '#D4AF37' }}
                >
                  Ore 18:00
                </div>
                <div
                  className="text-sm text-gray-400 mt-3"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Ingresso gratuito<br />su prenotazione
                </div>
              </div>

              {/* Separatore */}
              <div className="hidden md:flex flex-col items-center justify-start pt-2">
                <div className="w-px flex-1 min-h-40" style={{ background: 'linear-gradient(to bottom, transparent, #D4AF37, transparent)' }} />
              </div>
              <div className="block md:hidden h-px w-full" style={{ background: 'linear-gradient(to right, transparent, #D4AF37, transparent)' }} />

              {/* Luogo */}
              <div className="text-center md:text-left">
                <div className="w-14 h-14 flex items-center justify-center rounded-full border border-yellow-600/50 bg-yellow-600/10 mb-6 mx-auto md:mx-0">
                  <i className="ri-map-pin-line text-2xl" style={{ color: '#D4AF37' }} />
                </div>
                <div
                  className="text-xs tracking-widest uppercase text-gray-500 mb-3"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Luogo
                </div>
                <div
                  className="text-2xl font-bold text-white mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Tennis Club
                </div>
                <div
                  className="text-base text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Via Raffaele Viviani 7
                </div>
                <div
                  className="text-base font-semibold mt-1"
                  style={{ fontFamily: "'Montserrat', sans-serif", color: '#D4AF37' }}
                >
                  Pozzuoli (NA)
                </div>
              </div>
            </div>

            {/* Mappa Google */}
            <div className="mt-12">
              <div
                className="text-xs tracking-widest uppercase text-gray-500 mb-4 flex items-center gap-2"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                <i className="ri-map-2-line" style={{ color: '#D4AF37' }} />
                Come Arrivare
              </div>
              <div
                className="rounded-xl overflow-hidden border"
                style={{ borderColor: '#D4AF37', borderWidth: '1px', height: '280px' }}
              >
                <iframe
                  title="Filmodeling Open Day – Tennis Club Pozzuoli"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.1234567890!2d14.1208!3d40.8220!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b08c2b4c8f3c7%3A0x0!2sVia%20Raffaele%20Viviani%2C%207%2C%2080078%20Pozzuoli%20NA!5e0!3m2!1sit!2sit!4v1234567890"
                  width="100%"
                  height="280"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            {/* CTA */}
            <div className="mt-10 text-center">
              <button
                onClick={onCtaClick}
                className="whitespace-nowrap bg-gradient-to-r from-yellow-700 to-yellow-500 text-black font-bold tracking-widest uppercase px-6 sm:px-12 py-3.5 sm:py-4 rounded-md text-xs sm:text-sm hover:shadow-xl hover:shadow-yellow-700/40 hover:scale-105 transition-all duration-300 cursor-pointer w-full sm:w-auto"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                <span className="flex items-center justify-center gap-2 sm:gap-3">
                  <i className="ri-star-line text-base" />
                  <span className="sm:hidden">Prenota il Posto Gratis</span>
                  <span className="hidden sm:inline">Prenota il Tuo Posto Gratis</span>
                  <i className="ri-star-line text-base" />
                </span>
              </button>
              <p
                className="text-gray-500 text-xs mt-4 tracking-wide"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Posti limitati · Iscrizione gratuita
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
